module.exports = __webpack_public_path__ + "adb384231701bf9c8da36c9fac3fc5e7.svg";